import { FullUser, InvitationLink } from "../Common/types";
import { resolveNoContent, resolveWithBody } from "./Utils/utils";

export type InvitationLinkListing = {
    invitationLinks: InvitationLink[];
    users: Record<number, FullUser>;
};

export default {
    init(promiseRequest) {
        return {
            getListing(eventId: number): Promise<InvitationLinkListing> {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/invitation-links`,
                    json: true,
                    method: "get",
                }).then(resolveWithBody());
            },
            createNew(eventId: number, expirationTime: number): Promise<void> {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/invitation-links`,
                    json: {
                        expirationTime,
                    },
                    method: "post",
                }).then(resolveNoContent());
            },
            deleteLink(eventId: number, linkId: string): Promise<void> {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/invitation-links/${linkId}`,
                    json: true,
                    method: "delete",
                }).then(resolveNoContent());
            },
        };
    },
};
